import { Trans } from 'react-i18next';
import {
    StatusMapItem,
    StatusView,
    StatusViewProps,
} from 'src/components/StatusView/StatusView';
import { AgentApplicationStatus } from 'src/stores/AgentLoanApplicationsStore/AgentLoanApplicationsStore.types';
import { CssColors } from 'src/styles/CssVariables';

type LoanApplicationStatusViewProps = Omit<
    StatusViewProps,
    'statusMap' | 'status'
> & {
    status?: StatusViewProps['status'];
};

export const PartnerLoanApplicationStatusView = ({
    status,
    ...props
}: LoanApplicationStatusViewProps) => {
    return status ? (
        <StatusView
            status={status}
            statusMap={AgentLoanApplicationStatusMap}
            {...props}
        />
    ) : null;
};

export const AgentLoanApplicationStatusMap: StatusMapItem[] = [
    {
        status: AgentApplicationStatus.ASSIGNED,
        label: <Trans i18nKey="Agent.Applications.Status.Assigned" />,
        color: CssColors.textBlack,
        backgroundColor: CssColors.fillGrey,
        borderColor: CssColors.borderMediumGrey,
    },
    {
        status: AgentApplicationStatus.PENDING_ASSIGNMENT,
        label: <Trans i18nKey="Agent.Applications.Status.PendingAssignment" />,
        color: CssColors.textBlack,
        backgroundColor: CssColors.fillGrey,
        borderColor: CssColors.borderMediumGrey,
    },
    {
        status: AgentApplicationStatus.RETURNED_FOR_ASSIGNMENT,
        label: (
            <Trans i18nKey="Agent.Applications.Status.ReturnedForAssignment" />
        ),
        color: CssColors.textWhite,
        backgroundColor: CssColors.red,
        borderColor: CssColors.red,
    },
    {
        status: AgentApplicationStatus.DECLINED,
        label: <Trans i18nKey="Agent.Applications.Status.Declined" />,
        color: CssColors.textWhite,
        backgroundColor: CssColors.red,
        borderColor: CssColors.red,
    },
    {
        status: AgentApplicationStatus.ACTIVE,
        label: <Trans i18nKey="Agent.Applications.Status.Active" />,
        color: CssColors.textWhite,
        backgroundColor: CssColors.green,
        borderColor: CssColors.green,
    },
    {
        status: AgentApplicationStatus.FULLY_PAID,
        label: <Trans i18nKey="Agent.Applications.Status.FullyRepaid" />,
        color: CssColors.textWhite,
        backgroundColor: CssColors.pureBlack,
        borderColor: CssColors.pureBlack,
    },
];
